
import { createRoot } from 'react-dom/client'
import { ConvexProvider, ConvexReactClient } from 'convex/react'
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import Gleap from 'gleap'
import App from './App.tsx'
import './index.css'
import { appConfig } from './config/environment'

posthog.init('phc_3GyzVqBmq2qMqIAYX5Gnqe5lvBfYUQUwkDf2dutkm54', {
  api_host: 'https://us.i.posthog.com',
})

Gleap.initialize('w9gN3dxdGO56Kh2vzUjT4KwJ4nGiiX70')

const convex = new ConvexReactClient(appConfig.convex.url)
const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <PostHogProvider client={posthog}>
    <QueryClientProvider client={queryClient}>
      <ConvexProvider client={convex}>
        <ConvexAuthProvider client={convex}>
          <App />
        </ConvexAuthProvider>
      </ConvexProvider>
    </QueryClientProvider>
  </PostHogProvider>
);
